export default {"src":"/_next/static/media/data-creation-and-capture.6351ba43.svg","height":512,"width":640,"blurWidth":0,"blurHeight":0};